var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['userpic', _vm.size ? 'userpic--' + _vm.size : '']},[_c('img',{attrs:{"src":_vm.getImageSrc,"srcset":_vm.getImage2xSrc + ' 2x',"alt":_vm.$t('labels.photo')}})])}
var staticRenderFns = []

export { render, staticRenderFns }